import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { useAuth } from '../../contexts/AuthContext';
import { ReactComponent as TippiLogoLight } from '../../assets/logo-light.svg';
import { COLORS, FONTS, SHADOWS } from '../../styles/tokens';

export default function AcceptInvitePage() {
  const { token }   = useParams();
  const navigate    = useNavigate();
  const { currentUser, refreshUserDoc } = useAuth();

  const [loading,  setLoading]  = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [error,    setError]    = useState('');

  // Redirect unauthenticated users to register with the invite token
  useEffect(() => {
    if (!currentUser) {
      navigate(`/register?invite=${token}`, { replace: true });
    }
  }, [currentUser, token, navigate]);

  async function handleAccept() {
    setLoading(true);
    setError('');
    try {
      const functions     = getFunctions(undefined, 'europe-west1');
      const acceptInvite  = httpsCallable(functions, 'acceptOrgInvite');
      await acceptInvite({ token });
      await refreshUserDoc();
      setAccepted(true);
      setTimeout(() => navigate('/orderer'), 2000);
    } catch (err) {
      setError('Invitasjonslenken er ugyldig eller utløpt.');
    } finally {
      setLoading(false);
    }
  }

  if (!currentUser) return null; // redirecting

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <TippiLogoLight style={{ height: 32, width: 'auto', marginBottom: 16 }} />

        {accepted ? (
          <>
            <div style={styles.icon}>✅</div>
            <h2 style={styles.title}>Du er nå med i teamet!</h2>
            <p style={styles.body}>Du sendes til dashbordet om et øyeblikk…</p>
          </>
        ) : (
          <>
            <div style={styles.icon}>🏢</div>
            <h2 style={styles.title}>Invitasjon til team</h2>
            <p style={styles.body}>
              Du er invitert til å bli med i en organisasjon på Tippi. Trykk nedenfor for å akseptere.
            </p>

            {error && <div style={styles.error}>{error}</div>}

            <button
              className="tippi-btn"
              style={styles.btn}
              onClick={handleAccept}
              disabled={loading}
            >
              {loading ? 'Aksepterer…' : 'Aksepter invitasjon'}
            </button>

            <button
              className="tippi-btn-secondary"
              style={styles.btnSecondary}
              onClick={() => navigate('/orderer')}
              disabled={loading}
            >
              Avbryt
            </button>
          </>
        )}
      </div>
    </div>
  );
}

const styles = {
  page:        { minHeight: '100vh', background: COLORS.bg ?? '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  card:        { background: '#fff', borderRadius: 20, padding: 36, maxWidth: 420, width: '100%', boxShadow: SHADOWS.md, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 },
  icon:        { fontSize: 48 },
  title:       { fontFamily: FONTS.display, fontSize: 22, margin: 0, textAlign: 'center', color: COLORS.primary },
  body:        { fontSize: 15, color: COLORS.textLight ?? '#666', textAlign: 'center', lineHeight: 1.5, margin: 0 },
  error:       { background: '#fff0f0', border: '1px solid #ffb3b3', borderRadius: 8, padding: '10px 14px', fontSize: 14, color: '#c0392b', width: '100%', boxSizing: 'border-box', textAlign: 'center' },
  btn:         { width: '100%', padding: '14px', fontSize: 16, fontWeight: 700 },
  btnSecondary:{ width: '100%', padding: '12px', fontSize: 15 },
};
